var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167027",
    "data-name": "Group 167027",
    transform: "translate(-134 -51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    transform: "translate(137 56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_45",
    "data-name": "Line 45",
    d: "M12.442,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H12.442a1,1,0,0,1,1,1A1,1,0,0,1,12.442,1Z",
    transform: "translate(2.5 4.25)",
    fill: "#1c2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_69",
    "data-name": "Line 69",
    d: "M14.942,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H14.942a1,1,0,0,1,1,1A1,1,0,0,1,14.942,1Z",
    transform: "translate(0 9.735)",
    fill: "#1c2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    d: "M12,20.106a1,1,0,0,1-.707-1.707l6.346-6.346L11.293,5.707a1,1,0,0,1,1.414-1.414l7.053,7.053a1,1,0,0,1,0,1.414l-7.053,7.053A1,1,0,0,1,12,20.106Z",
    transform: "translate(-1.053 -5)",
    fill: "#1c2023"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send_icon.b0682ee58f1a270cafc03e501a3aabe1.svg";
export { ForwardRef as ReactComponent };